import React, { PureComponent, Fragment } from 'react';
import { object } from 'prop-types';
import { Container, Header } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

import {
  AssetDownloadsTable,
  Wrappers,
  PageHeader,
  Loader
} from '../components';
import { withPageViewTracking, withAnalytics } from '../analytics';
import { brochureAPIs } from '../api';
import { withAuth, AuthRoles } from '../auth';
import { BrandHelper } from '../utils';

const {
  swapImageEndpointForDownload,
  mapNameIfParentNull
} = AssetDownloadsTable.helpers;

class Brochures extends PureComponent {
  state = {
    allBrochures: null,
    brands: null,
    brochures: null,
    searchFilter: null,
    selectedBrand: null
  };

  static propTypes = {};

  async componentDidMount() {
    let brands, brochures;
    const { authUser } = this.props;

    const isAGIUser = AuthRoles.isAGIUser(authUser, 'roles');

    const authBrands = BrandHelper.filterAuthorizedBrands(
      authUser.brands,
      isAGIUser
    );
    try {
      const allBrands = await brochureAPIs.brands();
      brands = BrandHelper.filterAllBrandByAuthBrands(allBrands, authBrands);
      brochures = await brochureAPIs.search({});
    } catch (error) {
      if (!brands) {
        brands = { error: error.toString() };
      }
      if (!brochures) {
        brochures = { error: error.toString() };
      }
    }

    if (Array.isArray(brochures)) {
      brochures = brochures
        .map(brochure => {
          const { ProductBrand, ProductFamily, Language, FileLink } = brochure;
          // ensure expected attributes
          return {
            ...brochure,
            ProductBrand: mapNameIfParentNull(ProductBrand),
            ProductFamily: mapNameIfParentNull(ProductFamily),
            Language: mapNameIfParentNull(Language),
            FileLink: swapImageEndpointForDownload(FileLink)
          };
        })
        .filter(
          brochure =>
            // filter brands that are authorized for the user
            // no ability to pass certain brand params to api query
            isAGIUser ||
            brands.find(brand => brand.Name === brochure.ProductBrand.Name)
        );
    }

    this.setState({
      brands,
      brochures,
      allBrochures: brochures
    });
  }

  // used only for on Brand change now
  filterBrochures = () => {
    const { allBrochures, selectedBrand } = this.state;
    let brochures = allBrochures;
    // if brand filter has been selected; filter allbrochures
    if (selectedBrand && selectedBrand !== '') {
      brochures = allBrochures
        .filter(bro => {
          return bro.ProductBrand != null;
        })
        .filter(bro => bro.ProductBrand.Name === selectedBrand);
    }
    this.setState({ brochures });
  };

  handleBrandChange = selectedBrand => {
    this.setState({ selectedBrand }, () => {
      this.filterBrochures();
    });
  };

  handleSearchInput = e => {
    const searchFilter = e.target.value.toLowerCase();
    this.setState({ searchFilter });
  };

  render() {
    const {
      brands,
      brochures,
      allBrochures,
      selectedBrand,
      searchFilter
    } = this.state;
    const isLoading = !brands || !brochures || (brands && brands.error);

    return (
      <Wrappers.Layout menu>
        <Container as="main">
          {isLoading ? (
            <Loader active />
          ) : (
            <Fragment>
              <PageHeader overlap>
                <Header as="h1" data-qa="brochure-page-header">
                  <small>Marketing</small>
                  <FormattedMessage
                    id="title.brochures"
                    description="Brochure Title"
                    defaultMessage="Brochures"
                  />
                </Header>
              </PageHeader>

              <AssetDownloadsTable.FilterBar
                handleBrandChange={this.handleBrandChange}
                selectedBrand={selectedBrand ? selectedBrand : ''}
                brands={brands}
                handleSearchInput={this.handleSearchInput}
              />

              <AssetDownloadsTable.Body
                data={brochures}
                total={allBrochures && allBrochures.length}
                searchFilter={searchFilter}
                assetType="brochure"
                columns={[
                  {
                    Header: 'Brand',
                    accessor: 'ProductBrand.Name',
                    sortType: 'basic'
                  },
                  {
                    Header: 'Product series',
                    accessor: 'ProductFamily.Name',
                    sortType: 'basic'
                  },
                  {
                    Header: 'Product name',
                    accessor: 'BrochureName',
                    sortType: 'basic',
                    Cell: AssetDownloadsTable.Cells.FileName
                  },
                  {
                    Header: 'Language',
                    accessor: 'Language.Name',
                    sortType: 'basic'
                  },
                  {
                    Header: '',
                    accessor: 'FileLink',
                    Cell: AssetDownloadsTable.Cells.Download,
                    disableSortBy: true,
                    isCTA: true
                  }
                ]}
              />
            </Fragment>
          )}
        </Container>
      </Wrappers.Layout>
    );
  }
}

Brochures.propTypes = {
  authUser: object.isRequired
};

export default withPageViewTracking({ eventName: 'Brochures Page Visit' })(
  withAnalytics(withAuth(Brochures))
);
